import Settings from "../../components/settings.json";
import axios from "axios";
import config from "../../config/config";

export const logoutAction = () => {
  return (dispatch) => {
    axios
      .post(`${config.BASE_URL}${Settings.logoutAPI}`)
      .then(() => {
        dispatch({
          type: "LOGOUT_ACTION_SUCCESS",
        });
      })
      .catch(() => {
        dispatch({
          type: "LOGOUT_ACTION_ERROR",
        });
      });
  };
};
